import getEnvironment from '../getEnvironment/getEnvironment';

const getGaId = () => {
  if (getEnvironment() === 'UAT' || getEnvironment() === 'production') {
    return window.gaGlobal.vid;
  }
  // the window.gaGlobal.vid property is not available in environments below clone
  return 'developmentId';
};

export default getGaId;
